export enum volumeBasedPricingInterval {
  always = "always",
  hourly = "hourly",
  daily = "daily",
  monthly = "monthly",
  quarterly = "quarterly",
  sixMonths = "sixMonths",
  yearly = "yearly",
}
